// extracted by mini-css-extract-plugin
export default {"label":"styles_label__91x+B","altLabel":"styles_altLabel__U-ztM","required":"styles_required__fpBGq"};